<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container" *ngIf="isEdit && articalData">
  <button mat-mini-fab color="warn" class="float-right btn-delete"
    (click)="delete(articalData.DETAIL_ARTICAL[0].ARTICAL_ID)">
    <img src="../../../../assets/delete.png" style="width: 22px; margin-left: 4px; margin-top: -4px;">
  </button>
</div>

<!-- CREATE -->

<div class="container" *ngIf="!isEdit && !articalData">
  <h1 class="text-center lifedi-color">สร้างบทความ</h1>
  <form [formGroup]="articalForm">
    <div class="form-group row">
      <label for="topic" class="col-4 col-form-label text-right">หัวข้อบทความ<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <input type="text" class="form-control" id="topic" formControlName="articalTital" autocomplete="off">
      </div>
    </div>
    <div class="form-group row">
      <label for="cover" class="col-4 col-form-label text-right">รูปภาพปก<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="customFile" accept=".png, .jpg, .jpeg"
            (change)="onFileSelected($event, articalForm)">
          <label *ngIf="!coverName" class="custom-file-label" for="customFile">Choose file</label>
          <label *ngIf="coverName" class="custom-file-label" for="customFile">{{ coverName }}</label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-4 col-form-label text-right">ประเภท<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <select class="custom-select" id="type" formControlName="articalCategory">
          <option *ngFor="let c of category" [value]="c.CATEGORY_ID">{{ c.CATEGORY_NAME }}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="timeToClose" class="col-4 col-form-label text-right">เวลาเปิด /
        ปิดบทความ<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <input [attr.disabled]="articalForm.articalAlwaysOpen ? true : null " type="text"
          placeholder="เลือกเวลาเปิด / ปิดบทความ" class="form-control" formControlName="articalDate" bsDaterangepicker
          id="timeToClose" autocomplete="off"
          [bsConfig]="{ isAnimated: true, rangeInputFormat : ' DD-MM-YYYY ', dateInputFormat: ' DD-MM-YYYY ', showWeekNumbers: false, containerClass: 'theme-red' }">
      </div>
      <div class="col-2 justify-content-center align-self-center">
        <section>
          <mat-checkbox id="articalAlwaysOpen" color="primary" formControlName="articalAlwaysOpen"
            (click)="clearValueArticalDate(articalForm)" [(ngModel)]="articalForm.articalAlwaysOpen">เปิดตลอด
          </mat-checkbox>
        </section>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-4 col-form-label text-right">ศูนย์ย่อย</label>
      <div class="col-5">
        <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #value [change]="patchLearning(value, articalForm)"
          style="width: 100%" [compareWith]="compareFn">
          <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME"
            [nzValue]="center"></nz-option>
        </nz-select>
      </div>
    </div>
    <br />
    <h5 class="text-center">เนื้อหาบทความ<lifedi-require></lifedi-require></h5>
    <br />
    <angular-editor id="_content" formControlName="articalContent" placeholder="ใส่เนื้อหาบทความ"
      style="margin: 0 auto;" [config]="editorConfig">
    </angular-editor>
    <div class="container mt-4">
      <div class="row">
        <mat-checkbox class="offset-3 col-6" [(ngModel)]="havePoll" [ngModelOptions]="{standalone: true}">
          สร้างโพล
        </mat-checkbox>
      </div>
      <div *ngIf="havePoll" class="form-group row mt-3">
        <mat-card class="offset-3 col-6">
          <form [formGroup]="pollForm">
            <div class="form-group row mt-3 mb-3">
              <label for="pollTime"
                class="offset-1 col-4 col-form-label">วันเวลาเปิด/ปิดการโหวต<lifedi-require></lifedi-require></label>
              <div class="col-6">
                <input type="text" class="form-control" formControlName="pollTime" bsDaterangepicker id="pollTime"
                  autocomplete="off"
                  [bsConfig]="{ isAnimated: true, rangeInputFormat : ' DD-MM-YYYY ', dateInputFormat: ' DD-MM-YYYY ', showWeekNumbers: false, containerClass: 'theme-red' }">
              </div>
            </div>
            <div class="form-group row mt-3 mb-3">
              <label for="question" class="offset-1 col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
              <div class="col-8">
                <textarea type="text" class="form-control" id="question" formControlName="pollQuestion"
                  autocomplete="off" rows="5"></textarea>
              </div>
            </div>
            <div class="form-group row mt-3 mb-3">
              <label for="choice1" class="offset-3 col-1 col-form-label">C1<lifedi-require></lifedi-require></label>
              <div class="col-7">
                <input type="text" class="form-control" id="choice1" formControlName="pollChoice1" autocomplete="off">
              </div>
            </div>
            <div class="form-group row mt-3 mb-3">
              <label for="choice2" class="offset-3 col-1 col-form-label">C2<lifedi-require></lifedi-require></label>
              <div class="col-7">
                <input type="text" class="form-control" id="choice2" formControlName="pollChoice2" autocomplete="off">
              </div>
            </div>
          </form>
        </mat-card>
      </div>
    </div>
  </form>
  <div style="margin: 15px auto; padding-bottom: 10px; width: fit-content;">
    <lifedi-btn lable="Preview" *ngIf="havePoll && articalForm.valid && pollForm.valid"
      (click)="preview(articalForm.value, isEdit, pollForm.value)"
      customStyle="color:white; background-color: #414A6B; width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="Preview" *ngIf="(havePoll && !articalForm.valid) || (havePoll && !pollForm.valid)"
      [disabled]="true" customStyle="width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="Preview" *ngIf="!havePoll && articalForm.valid" (click)="preview(articalForm.value, isEdit)"
      customStyle="color:white; background-color: #414A6B; width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="Preview" *ngIf="!havePoll && !articalForm.valid" [disabled]="true" customStyle="width: 300px;">
    </lifedi-btn>
  </div>
</div>

<!-- EDIT -->

<div class="container" *ngIf="isEdit && articalData">
  <!-- {{ articalData|json }} -->
  <h1 class="text-center lifedi-color">แก้ไขบทความ</h1>
  <form [formGroup]="articalFormEdit">
    <div class="form-group row">
      <label for="topic" class="col-4 col-form-label text-right">หัวข้อบทความ<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <input type="text" class="form-control" id="topic" formControlName="articalTital" autocomplete="off"
          [(ngModel)]="articalData.DETAIL_ARTICAL[0].ARTICAL_TITAL">
      </div>
    </div>
    <div class="form-group row">
      <label for="cover" class="col-4 col-form-label text-right">รูปภาพปก<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="customFile" accept=".png, .jpg, .jpeg"
            (change)="onFileSelected($event, articalFormEdit)">
          <label *ngIf="!coverName" class="custom-file-label" for="customFile">Choose file</label>
          <label *ngIf="coverName" class="custom-file-label" for="customFile">{{ coverName }}</label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-4 col-form-label text-right">ประเภท<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <select class="custom-select" id="type" formControlName="articalCategory"
          [(ngModel)]="articalData.DETAIL_ARTICAL[0].ARTICAL_CATEGORY">
          <option *ngFor="let c of category" [value]="c.CATEGORY_ID">{{c.CATEGORY_NAME}}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="timeToClose" class="col-4 col-form-label text-right">เวลาเปิด /
        ปิดบทความ<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <input [attr.disabled]="articalData.DETAIL_ARTICAL[0].ALWAYS_OPEN ? true : null" type="text"
          placeholder="เลือกเวลาเปิด / ปิดบทความ" class="form-control" formControlName="articalDate" bsDaterangepicker
          id="timeToClose" autocomplete="off" [(ngModel)]="dateTime"
          [bsConfig]="{ isAnimated: true, rangeInputFormat : ' DD-MM-YYYY ', dateInputFormat: ' DD-MM-YYYY ', showWeekNumbers: false, containerClass: 'theme-red' }">
      </div>
      <div class="col-2 justify-content-center align-self-center">
        <section>
          <mat-checkbox id="articalAlwaysOpen" color="primary" formControlName="articalAlwaysOpen"
            (click)="clearValueArticalDate(articalFormEdit)" [(ngModel)]="articalData.DETAIL_ARTICAL[0].ALWAYS_OPEN">
            เปิดตลอด</mat-checkbox>
        </section>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-4 col-form-label text-right">ศูนย์ย่อย</label>
      <div class="col-5">
        <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #value [(ngModel)]="articalData.DETAIL_ARTICAL[0].LN_TAG"
          [ngModelOptions]="{standalone: true}" [change]="patchLearning(value, articalFormEdit)" style="width: 100%"
          [compareWith]="compareFn">
          <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME"
            [nzValue]="center"></nz-option>
        </nz-select>
      </div>
    </div>
    <br />
    <h5 class="text-center">เนื้อหาบทความ</h5>
    <br />
    <angular-editor id="_content" formControlName="articalContent" placeholder="ใส่เนื้อหาบทความ"
      style="margin: 0 auto;" [config]="editorConfig" [(ngModel)]="articalData.DETAIL_ARTICAL[0].ARTICAL_DETAIL">
    </angular-editor>
    <div class="container mt-4">
      <div class="row">
        <mat-checkbox class="offset-3 col-6" [(ngModel)]="havePoll" [ngModelOptions]="{standalone: true}">
          สร้างโพล
        </mat-checkbox>
      </div>
      <div *ngIf="havePoll" class="form-group row mt-3">
        <mat-card class="offset-3 col-6">
          <form [formGroup]="pollForm">
            <div class="form-group row mt-3 mb-3">
              <label for="pollTime"
                class="offset-1 col-4 col-form-label">วันเวลาเปิด/ปิดการโหวต<lifedi-require></lifedi-require></label>
              <div class="col-6">
                <input type="text" class="form-control" formControlName="pollTime" bsDaterangepicker id="pollTime"
                  autocomplete="off"
                  [bsConfig]="{ isAnimated: true, rangeInputFormat : ' DD-MM-YYYY ', dateInputFormat: ' DD-MM-YYYY ', showWeekNumbers: false, containerClass: 'theme-red' }">
              </div>
            </div>
            <div class="form-group row mt-3 mb-3">
              <label for="question" class="offset-1 col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
              <div class="col-8">
                <textarea type="text" class="form-control" id="question" formControlName="pollQuestion"
                  autocomplete="off" rows="5"></textarea>
              </div>
            </div>
            <div class="form-group row mt-3 mb-3">
              <label for="choice1" class="offset-3 col-1 col-form-label">C1<lifedi-require></lifedi-require></label>
              <div class="col-7">
                <input type="text" class="form-control" id="choice1" formControlName="pollChoice1" autocomplete="off">
              </div>
            </div>
            <div class="form-group row mt-3 mb-3">
              <label for="choice2" class="offset-3 col-1 col-form-label">C2<lifedi-require></lifedi-require></label>
              <div class="col-7">
                <input type="text" class="form-control" id="choice2" formControlName="pollChoice2" autocomplete="off">
              </div>
            </div>
          </form>
        </mat-card>
      </div>
    </div>
  </form>
  <div style="margin: 15px auto; padding-bottom: 10px; width: fit-content;">
    <lifedi-btn lable="Preview" *ngIf="havePoll && articalFormEdit.valid && pollForm.valid"
      (click)="preview(articalFormEdit.value, isEdit, pollForm.value)"
      customStyle="color:white; background-color: #414A6B; width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="Preview" *ngIf="(havePoll && !articalFormEdit.valid) || (havePoll && !pollForm.valid)"
      [disabled]="true" customStyle="width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="Preview" *ngIf="!havePoll && articalFormEdit.valid"
      (click)="preview(articalFormEdit.value, isEdit)"
      customStyle="color:white; background-color: #414A6B; width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="Preview" *ngIf="!havePoll && !articalFormEdit.valid" [disabled]="!articalFormEdit.valid"
      customStyle="width: 300px;">
    </lifedi-btn>
  </div>
</div>